export default __webpack_public_path__ + "static/media/6 - Субботники в парках.0cbd3f44.jpg";